import { Item } from '@/app/api/types/redpim.types'
import { useCallback, useMemo } from 'react'
import { useLocalStorage } from 'react-use'

const useCart = () => {
	const [cart, setCart] = useLocalStorage<Item[]>('cart', [])

	function add(item: Item) {
		if (cart.length) setCart([...cart, item])
		else setCart([item])
	}

	function remove(item: Item) {
		const itemIndex = cart.findIndex((i) => i.partnumber === item.partnumber)
		if (itemIndex < 0) {
			return cart
		}
		const update = [...cart]
		update.splice(itemIndex, 1)
		setCart(update)
	}

	function clear() {
		setCart([])
	}

	function removeProduct(item: Item) {
		const update = cart.filter((i) => i.partnumber !== item.partnumber)
		setCart(update)
	}

	const getAmountPerProduct = useCallback(
		(partnumber: string) =>
			cart.filter((item) => item.partnumber === partnumber).length,
		[cart],
	)

	const cartReduced = useMemo(() => {
		const tmp: string[] = []
		const cartReduced: Item[] = []
		for (const product of cart) {
			if (!tmp.includes(product.partnumber)) {
				tmp.push(product.partnumber)
				cartReduced.push(product)
			}
		}
		return cartReduced
	}, [cart])

	return {
		cart,
		cartReduced,
		add,
		remove,
		clear,
		getAmountPerProduct,
		removeProduct,
	}
}

export default useCart
